export default "__VITE_ASSET__95e5951a__"